/**
 * Application Entry Point
 * 
 * Initializes the React application and mounts it to the DOM.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';

// Get root element
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

// Create root and render app
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);